import { createContext, useContext } from 'react';
import type { BackoffPolicy, TicketClient } from './types';

export interface TaskEventStreamConfig {
  baseUrl: string;
  ticketClient: TicketClient;
  backoff: BackoffPolicy;
  heartbeatTimeoutMs: number;
}

export const TaskEventStreamContext = createContext<TaskEventStreamConfig | null>(null);

export function useTaskEventStreamConfig(): TaskEventStreamConfig {
  const config = useContext(TaskEventStreamContext);
  if (!config) {
    throw new Error('TaskEventStreamProvider missing');
  }
  return config;
}
